<template>
  <Tooltip>
    <template #element>
      <span>
        Alternativer Titel (optional, um z.B. einen Kampagnenbezug herzustellen)
      </span>
      <InformationCircleIcon class="info-icon" />
    </template>
    <template #content>
      <span>
        Jedes Experiment trägt automatisch den Titel der ausgewählten Methode. Du kannst diesen aber abändern, wenn du spezifischer werden möchtest
      </span>
    </template>
  </Tooltip>
</template>

<style scoped>
.info-icon
{
  @apply h-5 w-5 inline-block;
  @apply text-gray-400;
}
</style>
